<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">
        {{
          isBatch
            ? t('manageEnrollment.dropChild.batchTitle')
            : t('manageEnrollment.dropChild.title')
        }}
      </h1>
      <i
        mat-button
        mat-dialog-close
        class="text-drdpblue-300 cursor-pointer uil uil-times-circle"
      ></i>
    </div>

    <div mat-dialog-content>
      <form class="grid grid-cols-2 gap-x-10" [formGroup]="dropForm">
        @if (isBatch) {
          <div class="col-span-2 mt-2">
            <label class="font-normal mb-2" for="childName"
              >{{ t('manageEnrollment.common.selectedChildren') }}</label
              >
              <ul>
                @for (child of child; track child) {
                  <li>
                    <!-- Server-supplied: child name comes from the API. -->
                    {{ child.firstName + " " + child.lastName }}
                  </li>
                }
              </ul>
            </div>
          }

          @if (!isBatch) {
            <div class="col-span-1 mt-2">
              <label class="font-normal mb-2" for="childName">{{
                t('manageEnrollment.common.childName')
              }}</label>
              <p>
                <!-- Server-supplied: child name comes from the API. -->
                {{ child.firstName + " " + child.lastName }}
              </p>
            </div>
          }

          <div class="input-container col-span-full md:col-span-1 mt-2">
            <mat-form-field
              class="example-full-width no-underline"
              appearance="fill"
              >
              <label class="font-normal"
                >{{ t('manageEnrollment.dropChild.exitReasonLabel')
                }}<span class="required"></span
              ></label>
              <mat-select
                formControlName="classExitReasonId"
                [placeholder]="t('manageEnrollment.dropChild.reasonPlaceholder')"
              >
                @for (reason of exitReasons$ | async; track reason) {
                  <mat-option
                    [value]="reason.id"
                    (click)="getSelectedExitReason(reason)"
                    >
                    <!-- Server-supplied: exit reason text comes from the API. -->
                    {{ reason.exitReason }}</mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="relative">
              <div class="col-span-1 mt-2">
                <drdp-date-picker
                  [label]="t('manageEnrollment.dropChild.withdrawDateLabel')"
                  [initialDate]="dropForm.get('exitDate').value"
                  [isRequired]="true"
                  (emitDate)="handleDate($event)"
                  >
                </drdp-date-picker>
              </div>
              <div class="absolute top-0 left-full mt-3 ml-[-2px]">
                <i class="uil uil-info-circle text-xs" [matTooltip]="t('manageEnrollment.dropChild.withdrawDateInfo')"></i>
              </div>
            </div>

            <div class="col-span-full">
              <mat-form-field class="bg-white" appearance="fill">
                <label class="font-normal" for="comment">{{
                  t('manageEnrollment.dropChild.commentLabel')
                }}</label>
                <input
                  matInput
                  [placeholder]="t('manageEnrollment.dropChild.commentPlaceholder')"
                  autocomplete="off"
                  type="text"
                  formControlName="comment"
                  maxlength="150"
                  />
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
      <div mat-dialog-actions class="flex justify-end">
        <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('manageEnrollment.common.cancel') }}</drdp-btn>
        <drdp-btn
          class="ml-3"
          mat-button
          [disabled]="dropForm.invalid || isProcessing"
          cdkFocusInitial
          (click)="onSubmit()"
          >{{ t('manageEnrollment.dropChild.submit') }}
        </drdp-btn>
      </div>
</ng-container>
